import { polarClient } from '@polar-sh/better-auth';
import { magicLinkClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

export const { signIn, signUp, useSession } = createAuthClient({
  plugins: [magicLinkClient(), polarClient()]
});
